import { useState } from 'react';

export type ViewMode = 'grid' | 'list';

/** Вид раздела запоминается в браузере: у каждого раздела свой. */
export function useViewMode(section: string): [ViewMode, (mode: ViewMode) => void] {
  const key = `faceta.view.${section}`;
  const [mode, setMode] = useState<ViewMode>(() => {
    try {
      return localStorage.getItem(key) === 'list' ? 'list' : 'grid';
    } catch {
      return 'grid';
    }
  });

  return [
    mode,
    (next) => {
      setMode(next);

      try {
        localStorage.setItem(key, next);
      } catch {
        // Не запомнилось — до перезагрузки и так видно.
      }
    },
  ];
}
